import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import { lessonsCount, quizzesCount } from '../../../utility/coachCertification'
import AvatarPlaceholder from '../../../assets/images/mock/default-profile-icon.png'

import classes from './CertificationSummary.module.scss'

const CertificationSummary = ({ certification }) => {
  const { t } = useTranslation()
  const stats = [
    { key: 'sections', value: certification.sections.length },
    { key: 'lessons', value: lessonsCount(certification) },
    { key: 'quizzes', value: quizzesCount(certification) },
  ]

  return (
    <section className={classes.card}>
      <div className={classNames('d-flex flex-wrap', classes.stats)}>
        {stats.map(stat => (
          <div key={stat.key}>
            <div className={classes.statValue}>{stat.value}</div>
            <div className={classes.statLabel}>{t(`portal.certification.details.stats.${stat.key}`)}</div>
          </div>
        ))}
      </div>
      {certification.bullets.length > 0 && (
        <ul className={classNames('list-unstyled mb-0', classes.includes)}>
          {certification.bullets.map(bullet => (
            <li key={bullet} className='d-flex align-items-start'>
              <i className='fa fa-check' aria-hidden='true' />
              {bullet}
            </li>
          ))}
        </ul>
      )}
      {certification.instructors.length > 0 && (
        <div className={classNames('d-flex align-items-center flex-wrap', classes.instructors)}>
          <span className={classes.instructorsLabel}>{t('portal.certification.details.taughtBy')}</span>
          {certification.instructors.map(instructor => (
            <span key={instructor.id} className={classNames('d-inline-flex align-items-center', classes.instructor)}>
              <img src={instructor.avatar?.fileUrl || AvatarPlaceholder} alt='' className={classes.avatar} />
              {instructor.firstName} {instructor.lastName}
            </span>
          ))}
        </div>
      )}
    </section>
  )
}

CertificationSummary.propTypes = {
  certification: PropTypes.shape({
    sections: PropTypes.array.isRequired,
    bullets: PropTypes.arrayOf(PropTypes.string).isRequired,
    instructors: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      avatar: PropTypes.shape({ fileUrl: PropTypes.string }),
    })).isRequired,
  }).isRequired,
}

export default CertificationSummary
